module.exports = __webpack_public_path__ + "01_face.361a7895.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer1/01_face.png
// module id = VyHP
// module chunks = 0